module.exports = __webpack_public_path__ + "img/Postmodernisme_Einar-Okland.8e2d6dd5.jpg";